import { render, staticRenderFns } from "./TicketConversation.vue?vue&type=template&id=95ae11c6&scoped=true"
import script from "./TicketConversation.vue?vue&type=script&lang=js"
export * from "./TicketConversation.vue?vue&type=script&lang=js"
import style0 from "./TicketConversation.vue?vue&type=style&index=0&id=95ae11c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ae11c6",
  null
  
)

export default component.exports